import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { AirlineInfo, airlineSliceInterface } from './airlineData.interface';

const initialState: airlineSliceInterface = {
  loading: true,
  data: null,
  meta: null,
  error: null,
  airlineProducts: [],
};

export const airlineSlice = createSlice({
  name: 'airline',
  initialState,
  reducers: {
    setAirline: (state, action: PayloadAction<AirlineInfo>) => {
      state.airlineProducts = action.payload.airlineProducts;

      state.loading = false;
      state.error = null;
    },
    setAirlinesLoading(state) {
      state.loading = true;
    },
    setAirlinesError(state, action: PayloadAction<any>) {
      state.airlineProducts = [];

      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setAirline, setAirlinesLoading, setAirlinesError } = airlineSlice.actions;

export const airlineLoadingState = (state: RootState) => state.airline.loading;
export const airlineState = (state: RootState) => state.airline.airlineProducts;

export default airlineSlice.reducer;
